<template>
  <div class="box flexiblock">
    <loading-container :state="state" errormsg="Beim Laden der Anwendungen ist ein Fehler aufgetreten. Bitte probieren Sie es nochmals oder kontaktieren Sie den Help-Desk: help-desk@brz.gv.at">
      <div class="d-flex align-items-center mb-2">
        <h2 class="mb-0">{{ header || 'personalisierte Findok Neuzugänge' }}<!--<span v-if="findokItemsCount > 0"> ({{ findokItemsCount }})</span>--></h2>
        <button
          @click="reload()"
          type="button"
          class="btn py-0 text-primary ml-auto"
          id="rssfindok-refresh-sidebar"
          :title="`Aktualisiert am ` + getNowFormatted()"
          >
          <span class="icon icon-ladekreisel" aria-hidden="true"></span><span class="sr-only">Daten neuladen</span>
        </button>
      </div>

      <div v-if="error" class="mb-3">
        Derzeit keine Neuzugänge vorhanden.
      </div>

      <ul v-else class="list-unstyled">
        <li class="show-arrow mb-2" v-for="(findokItem, index) in findokItems" :key="index">
          <div>{{ getNiceDate(findokItem.pubDate) }}</div>
          <a v-if="findokItem && findokItem.link" :href="sanitizeUrl(findokItem.link)" target="_blank" rel="noopener">
          <button class="btn btn-link btn-collapse" type="button">
            {{ findokItem.title }}
            <span class="icon icon-navigation_pfeil_klein_rechts" aria-hidden="true"></span>
          </button>
          </a>
          <!-- don't show description, according to mail by Topitz on 2024-11-28
          <div class="collapse show">
            <div class="pmb1" v-html="sanitizeHtml(findokItem.description || '')"></div>
          </div>
          -->
        </li>
      </ul>

      <div v-if="findokExternalUrl" class="show-arrow font-weight-bold mb-3">
        <a :href="sanitizeUrl(findokExternalUrl)" target="_blank" rel="noopener">
          {{ findokExternalUrlText ? findokExternalUrlText : findokExternalUrl }}
        </a>
      </div>
    </loading-container>
  </div>
</template>
<script lang="ts">
import LoadingMixin from '@/mixins/LoadingMixin'
import { LoadingState } from "@/utils/loadingUtils"
import LoadingContainer from '@/components/structure/LoadingContainer.vue'
import { defineComponent } from 'vue'
import CONFIG from '@/config/config'
import { FindokItem } from '@/models/RSSFindokModels'
import { sanitizeHtml } from '@/utils/domUtils'
import { sanitizeUrl } from '@braintree/sanitize-url'
import rssfindokService from '@/services/rssfindokService'

export default defineComponent({
  name: 'WidgetRSSFindok',
  components: {
    LoadingContainer
  },
  mixins: [
    LoadingMixin
  ],
  created() {
    this.loadFromServer()
  },
  data() {
    return {
      findokItems: [] as FindokItem[],
      error: false,
      findokUrl: CONFIG.rssfindokUrl,
      header: CONFIG.rssfindokHeader,
      mockResults: CONFIG.rssfindokMockResults,
      findokExternalUrl: CONFIG.rssfindokExternalUrl,
      findokExternalUrlText: CONFIG.rssfindokExternalUrlText,
      sanitizeHtml: sanitizeHtml,
      sanitizeUrl: sanitizeUrl
    }
  },
  computed: {
    findokItemsCount(): number {
      // TODO this is not the real count of new findok items - instead take info from api - atm not available
      return (this.findokItems.length) || 0
    }
  },
  methods: {
    loadFromServer() {
      rssfindokService.getFindokItems(this.findokUrl, this.mockResults)
      .then((findokItems) => {
        this.findokItems = findokItems;

        if(this.findokItems.length > 0) {
          this.error = false;
        } else {
          this.error = true;
        }
        this.handleSuccess()
      //}).catch(err =>{
      }).catch(() =>{
        this.error = true;
        // this.handleError(err);
        // we want to show no entries but also no error message
        this.handleSuccess()
      }
      )
    },
    getNiceDate(date?: Date): string {
      const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: '2-digit', day: '2-digit', hour12: false };
      if (!date) {
        return ''
      } else {
        return new Intl.DateTimeFormat('de-DE', options).format(date);
      }
    },
    getNowFormatted(): string {
        const nowDate = new Date();
        const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false };
        return new Intl.DateTimeFormat('de-DE', options).format(nowDate);
    },
    reload() {
      this.state = LoadingState.loading
      this.findokItems = []
      this.loadFromServer()
    }
  }
})
</script>

<style scoped>
.bm-icon{
  padding: 20px 20px 12px 10px !important;
  height: 20px;
}
.area-sidebar .box a.underline::after,
.area-sidebar .box a{
  text-decoration: none !important;
}

.pmb1 ::v-deep p {
  margin-bottom: 0.25rem !important;
}

.btn-collapse {
  font-size: 0.875rem;
  font-weight: 700;
  text-align: left;
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
  line-height: 1.25rem;
  width: 100%;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
}

.btn-collapse .icon {
  font-size: 1rem;
  font-weight: 700;
}

.btn-collapse[aria-expanded="true"] .icon {
  rotate: 90deg;
}

.new-dot {
  width: 6px;
  height: 6px;
  margin-left: 8px;
  border-radius: 100%;
  background-color: #286f9c;
}

a {
  text-decoration: none;
}

</style>
